module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "ask-topic",
      "has-comments": _vm.hasComments,
      "detail": _vm.detail,
      "auto-open-app": false
    }
  }, [_c('div', {
    staticClass: "m-focus bg-d",
    style: ({
      height: _vm.focusImgH
    })
  }, [_c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.webp(_vm.detail.image) + ')'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "praise-num"
  }, [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.detail.false_zan_num)))]), _vm._v(" "), _c('h4', {
    staticClass: "title f-toe1"
  }, [_vm._v(_vm._s(_vm.detail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "m-desc"
  }, [_c('div', {
    staticClass: "text f-taj",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.interpretation)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "more-btn"
  })]), _vm._v(" "), (_vm.showRelated) ? _c('div', {
    staticClass: "m-related"
  }, [_c('h4', {
    staticClass: "m-bt"
  }, [_c('span', {
    staticClass: "u-tt"
  }, [_vm._v("相关问题")])]), _vm._v(" "), _c('ul', _vm._l((_vm.related), function(item, index) {
    return _c('li', [_c('a', {
      class: ['f-cb', 'ask-link', 'status-' + item.status]
    }, [(item.image) ? _c('div', {
      staticClass: "f-fl col-l bg-d"
    }, [_c('div', {
      staticClass: "bg-c",
      style: ({
        backgroundImage: 'url(' + _vm.webp(item.image) + ')'
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "f-toe2 col-m"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "info-l f-toe1"
    }, [(item.status + '' === '3') ? _c('span', [_vm._v(_vm._s(item.rep_user_name) + "回复")]) : _vm._e(), _vm._v(" \n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "info-r"
    }, [_c('span', {
      staticClass: "praise-num"
    }, [_vm._v(_vm._s(_vm._f("numberFormat")(item.like_num)))]), _vm._v(" "), _c('span', {
      staticClass: "comment-num"
    }, [_vm._v(_vm._s(_vm._f("numberFormat")(item.comment_num)))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('comment-normal', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cca94c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-ask-topic.vue
// module id = 845
// module chunks = 2